import React, { ChangeEventHandler, KeyboardEventHandler } from 'react';
import { searchSvg } from 'components/ComponentExhibitor/AllForExhibitor';

import './SearchRow.css';

interface IExhibitorStyleSearchProps {
  value: string;
  placeholder: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onSearch: () => void;
  afterContent?: React.ReactNode;
  afterContentClassName?: string;
  afterContentWithDivider?: boolean;
  inputRef?: React.RefObject<HTMLInputElement>;
  onCompositionStart?: React.CompositionEventHandler<HTMLInputElement>;
  onCompositionEnd?: React.CompositionEventHandler<HTMLInputElement>;
  searchIconPosition?: 'front' | 'back';
  inputStyle?: React.CSSProperties;
}

const ExhibitorStyleSearch = ({
  value,
  placeholder,
  onChange,
  onSearch,
  afterContent,
  afterContentClassName,
  afterContentWithDivider = true,
  inputRef,
  onCompositionStart,
  onCompositionEnd,
  searchIconPosition = 'front',
  inputStyle,
}: IExhibitorStyleSearchProps) => {
  const handleKeyDown: KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onSearch();
    }
  };

  return (
    <div className="exhibitor-style-search">
      {searchIconPosition === 'front' ? (
        <div
          className="search-icon"
          style={{
            width: 24,
            height: 24,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            opacity: 0.5,
          }}
          onClick={onSearch}
        >
          {React.cloneElement(searchSvg as React.ReactElement, {
            style: {
              width: '20px',
              height: '20px',
              display: 'block',
            },
          })}
        </div>
      ) : null}
      <input
        ref={inputRef}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        onCompositionStart={onCompositionStart}
        onCompositionEnd={onCompositionEnd}
        style={inputStyle}
      />
      {afterContent ? (
        <div
          className={[
            'search-after',
            afterContentWithDivider ? 'with-divider' : '',
            afterContentClassName || '',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          {afterContent}
        </div>
      ) : null}
    </div>
  );
};

export default ExhibitorStyleSearch;